var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, KompisElement, property } from '@inter-ikea-kompis/web-component';
import { ThemeFontStyleTypeEnum } from '@inter-ikea-kompis/enums';
import { Text } from '@inter-ikea-kompis/component-text';
import CheckboxGroupStyle from './CheckboxGroupStyle.js';
/**
 * This component should be used for adding some styles around checkboxes.
 */
export default class CheckboxGroup extends KompisElement {
    constructor() {
        super(...arguments);
        // Help text describing the purpose of this checkbox group.
        this.helpText = null;
        // Heading.
        this.heading = null;
    }
    /**
     * Renders the component.
     *
     * @returns Template.
     */
    render() {
        return html `
			<style>
				${CheckboxGroupStyle.getStyle({
            theme: this.theme
        })}
			</style>
			${this.getHeading()}
			<div class="container">
				<slot></slot>
			</div>
			${this.getHelpText()}
			</div>
		`;
    }
    connectedCallback() {
        this.customElements.define('kompis-text', Text);
        super.connectedCallback();
    }
    /**
     * Render the group name.
     *
     * @returns Template.
     */
    getHeading() {
        if (!this.heading) {
            return null;
        }
        return html `
			<div class="heading">
				<kompis-text .theme="${this.theme}" .type="${ThemeFontStyleTypeEnum.headingXSmall}"
					>${this.heading}</kompis-text
				>
			</div>
		`;
    }
    /**
     * Render the group name.
     *
     * @returns Template.
     */
    getHelpText() {
        if (!this.helpText) {
            return null;
        }
        return html `
			<div class="help">
				<kompis-text .theme="${this.theme}" .type="${ThemeFontStyleTypeEnum.bodyMedium}"
					>${this.helpText}</kompis-text
				>
			</div>
		`;
    }
}
__decorate([
    property({ type: String })
], CheckboxGroup.prototype, "helpText", void 0);
__decorate([
    property({ type: String })
], CheckboxGroup.prototype, "heading", void 0);
__decorate([
    property({ type: Object, required: true })
], CheckboxGroup.prototype, "theme", void 0);
//# sourceMappingURL=CheckboxGroup.js.map